import { Routes, Route, Navigate, Link } from 'react-router-dom'
import {
  Login,
  Dashboard,
  Properties,
  PropertyCreate,
  PropertyEdit,
  Contact,
  Buildings,
  BuildingCreate,
  BuildingEdit,
  Viviendas,
} from './pages'
import { ProtectedRoute, AdminLayout } from './components'
import Reservations from './pages/Reservations'
import LeadReports from './pages/LeadReports'
import StaffAccess from './pages/StaffAccess'

/**
 * Componente principal de la aplicación con configuración de rutas.
 * Usa el envoltorio ProtectedRoute para rutas autenticadas.
 * Usa AdminLayout para diseño consistente en todas las páginas de administración.
 *
 * Note: Auth callbacks are handled internally by Clerk's SignIn component.
 */
export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />

      {/* Protected routes - wrapped in AdminLayout */}
      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/properties/create" element={<PropertyCreate />} />
        <Route path="/properties/:id/edit" element={<PropertyEdit />} />
        <Route path="/buildings" element={<Buildings />} />
        <Route path="/buildings/create" element={<BuildingCreate />} />
        <Route path="/buildings/:id/edit" element={<BuildingEdit />} />
        <Route path="/viviendas" element={<Viviendas />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/reports/leads" element={<LeadReports />} />
        <Route path="/accesos" element={<StaffAccess />} />
        {import.meta.env.VITE_RESERVATIONS_ENABLED === 'true' && <Route path="/reservations" element={<Reservations />} />}
      </Route>

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* 404 fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

/**
 * Componente de página 404 No Encontrada.
 */
function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-6xl font-bold">404</h1>
        <p className="mt-4 text-xl text-muted-foreground">Página no encontrada</p>
        <Link
          to="/dashboard"
          className="mt-8 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Ir al Panel
        </Link>
      </div>
    </div>
  )
}
